// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3CE9V","header":"ReportDetails_header__3VIEv","title":"ReportDetails_title__1VR3K","left":"ReportDetails_left__3p-Jh"};